import { clsx } from 'clsx'
import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import styles from './GridWrapper.module.scss'
import AppContext from '@/types/context'
import SectionTitle from '@/components/SectionTitle/SectionTitle'
import { isArticlePage } from '@/utils/app/detect'

export interface GroupGridProps {
  children: Array<PartialWidgetContext>
  model: {
    fields: {
      variant: 'default' | 'aside'
      headline: string
      link?: any
    }
  }
}

const GridWrapper = ({ item, context }: { item: GroupGridProps; context: AppContext }) => {
  return (
    <div className={clsx(styles.wrapper, item?.model.fields?.variant === 'aside' && 'grid-wrapper-aside')}>
      {item.model?.fields?.headline && (
        <SectionTitle
          title={item.model.fields?.headline}
          link={item.model?.fields?.link}
          asHeadline={!isArticlePage(context.metadata)}
        />
      )}
      <div className={clsx(styles.container, styles[item.model.fields.variant])}>
        {item.children.map((widget: PartialWidgetContext, index) => {
          return <Partials key={index} item={widget as any} context={context} />
        })}
      </div>
    </div>
  )
}

export default GridWrapper
